// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"d07d59ac","977":"5ef7e84c"}[chunkId] + ".chunk.js";
};